import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { HOST } from "Constant/Constant";

export const salesLeadsApi = createApi({
  reducerPath: "salesLeadsApi",
  baseQuery: fetchBaseQuery({
    baseUrl: HOST,
  }),
  tagTypes: ["SalesLeads"],
  endpoints: (builder) => ({
    getSalesLeadsList: builder.query({
      query: ({ page, limit, assignedTo, status, startDate, endDate, search, _id, sortBy, sortOrder } = {}) => {

        const params = new URLSearchParams();
        if (_id) params.set("_id", _id);
        if (page) params.set("page", page);
        if (limit) params.set("limit", limit);
        if (assignedTo) params.set("assignedTo", assignedTo);
        if (Array.isArray(status)) status.forEach((s) => params.append("status", s));
        else if (status) params.set("status", status);
        if (startDate) params.set("startDate", startDate);
        if (endDate) params.set("endDate", endDate);
        if (search?.trim()) params.set("search", search?.trim());
        if (sortBy) params.set("sortBy", sortBy);
        if (sortOrder) params.set("sortOrder", sortOrder);
        return {
          url: `/get-sales-leads?${params.toString()}`,
          method: "GET",
          headers: {
            authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        };
      },
      providesTags: ["SalesLeads"],
    }),

    createSalesLead: builder.mutation({
      query: ({ body }) => ({
        url: "/create-sales-lead",
        method: "POST",
        body,
        headers: {
          authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }),
      invalidatesTags: ["SalesLeads"],
    }),

    importSalesLead: builder.mutation({
      query: ({ sheetBase64 }) => {
        const formData = new FormData();
        formData.append("sheetBase64", sheetBase64);
        return {
          url: "/bulk-import-sales-leads",
          method: "POST",
          body: formData,
            headers: {
            authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        };
      },
      invalidatesTags: ["SalesLeads"],
    }),

    updateSalesLead: builder.mutation({
      query: ({ body }) => ({
        url: "/update-sales-lead",
        method: "POST",
        body,
        headers: {
          authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }),
      invalidatesTags: ["SalesLeads"],
    }),

    createSalesLeadRequestDemo: builder.mutation({
      query: ({ body }) => ({
        url: "/sales-lead-request-demo",
        method: "POST",
        body,
        headers: {
          authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }),
      invalidatesTags: ["SalesLeads"],
    }),

    updateSalesLeadRequestDemo: builder.mutation({
      query: ({ body }) => ({
        url: "/sales-lead-update-demo",
        method: "PATCH",
        body,
        headers: {
          authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }),
      invalidatesTags: ["SalesLeads"],
    }),

    createSalesLeadRequestLive: builder.mutation({
      query: ({ body }) => ({
        url: "/sales-lead-request-live",
        method: "POST",
        body,
        headers: {
          authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }),
      invalidatesTags: ["SalesLeads"],
    }),

    updateSalesLeadRequestLive: builder.mutation({
      query: ({ body }) => ({
        url: "/sales-lead-update-live",
        method: "PATCH",
        body,
        headers: {
          authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }),
      invalidatesTags: ["SalesLeads"],
    }),

    leadApproveDemo: builder.mutation({
      query: ({ body }) => ({
        url: "/lead-approve-demo",
        method: "POST",
        body,
        headers: {
          authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }),
      invalidatesTags: ["SalesLeads"],
    }),

    leadApproveLive: builder.mutation({
      query: ({ body }) => ({
        url: "/lead-approve-live",
        method: "POST",
        body,
        headers: {
          authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }),
      invalidatesTags: ["SalesLeads"],
    }),
  }),
});

export const {
  useGetSalesLeadsListQuery,
  useCreateSalesLeadMutation,
  useImportSalesLeadMutation,
  useUpdateSalesLeadMutation,
  useCreateSalesLeadRequestDemoMutation,
  useUpdateSalesLeadRequestDemoMutation,
  useCreateSalesLeadRequestLiveMutation,
  useUpdateSalesLeadRequestLiveMutation,
  useLeadApproveDemoMutation,
  useLeadApproveLiveMutation,
} = salesLeadsApi;
